__turbopack_context__.v({
  "root": "ghbHwq_root",
  "scrollbar": "ghbHwq_scrollbar",
  "thumb": "ghbHwq_thumb",
  "viewport": "ghbHwq_viewport",
});
